import type { FC } from 'react';
import { useState } from 'react';
import type { LibraryBlockTypeForListPage } from '@ContractBuilder/types';

import { useBlockLibraryTable } from '../hooks/use-block-library-table';
import { BlockLibraryListSuccess, BlocksLibraryLoading } from '../views';

interface BlockLibraryCreatorListControllerProps {
  onInsertBlock: (blockLibraryId: string, block: LibraryBlockTypeForListPage | null) => Promise<void>;
  type: 'block' | 'clause';
}

export const BlockLibraryCreatorListController: FC<BlockLibraryCreatorListControllerProps> = ({
  onInsertBlock,
  type,
}) => {
  const [previewBlockId, setPreviewBlockId] = useState<string | undefined>(undefined);
  const onPreviewToggle = (blockId: string) =>
    setPreviewBlockId((current) => (current === blockId ? undefined : blockId));

  const {
    table,
    isClause,
    isFetching,
    columnFilters,
    globalFilter,
    highlightedBlocks,
    total,
    infiniteLoaderRef,
    isGroupByParent,
    setIsGroupByParent,
    onSearchApply,
    handleLoadMoreItems,
  } = useBlockLibraryTable(type);

  if (isFetching) {
    return <BlocksLibraryLoading />;
  }

  return (
    <BlockLibraryListSuccess
      blocks={highlightedBlocks}
      count={highlightedBlocks.length}
      filters={columnFilters}
      listRef={infiniteLoaderRef}
      onInsert={onInsertBlock}
      onSearch={onSearchApply}
      searchText={globalFilter}
      total={total}
      onLoadMoreItems={handleLoadMoreItems}
      isClause={isClause}
      isFetching={isFetching}
      table={table}
      isGroupByParent={isGroupByParent}
      setIsGroupByParent={setIsGroupByParent}
      previewBlockId={previewBlockId}
      onPreviewToggle={onPreviewToggle}
    />
  );
};
